(function() {
  'use strict';

  angular.module('ringbaPortal').component('existingEventCallbacks', {
    bindings: {
      currentCampaign: '<',
      eventCallbacks: '<',
      onSave: '&',
      onDismiss: '&'
    },
    controller: ExistingEventCallbacksController,
    controllerAs: 'vm',
    bindToController: true,
    templateUrl: '/scripts/shared/components/select-event-callbacks/existing-event-callbacks.view.html'
  });

  function ExistingEventCallbacksController(
    $filter,
    accountsService,
    campaignServiceNew,
    toaster,
    utils
  ) {
    'ngInject';

    const vm = this;
    vm.onSubmit = onSubmit;

    function onSubmit() {
      return _linkToCampaign(vm.currentEventCallback.id).then(function () {
        toaster.pop('success', $filter('translate')('PIXEL_ADDED_SUCCESS'));
        vm.onDismiss({
          $event: {
            eventCallback: vm.currentEventCallBack
          }
        });
        vm.onSave();
      }).catch(utils.errorHandler);
    }

    function _linkToCampaign(eventCallBackId) {
      return campaignServiceNew.link(accountsService.currentAccountId, vm.currentCampaign.id, eventCallBackId, 'eventCallBacks');
    }
  }
})();
